export const UNITS: any[] = [
  {
    id: "Bag",
    name: "Bag",
  },
  {
    id: "Box",
    name: "Box",
  },
  {
    id: "Case",
    name: "Case",
  },
  {
    id: "Drum",
    name: "Drum",
  },
  {
    id: "Gram",
    name: "Gram",
  },
  {
    id: "Kg",
    name: "Kg",
  },
  {
    id: "LT",
    name: "LT",
  },
  {
    id: "Meter",
    name: "Meter",
  },
  {
    id: "MT",
    name: "MT",
  },
  {
    id: "Reel",
    name: "Reel",
  },
  {
    id: "Roll",
    name: "Roll",
  },
  {
    id: "Set",
    name: "Set",
  },
  {
    id: "Tank",
    name: "Tank",
  },
  {
    id: "UNT",
    name: "UNT",
  },
  {
    id: "Carton",
    name: "Carton",
  },
  {
    id: "Tin",
    name: "Tin",
  },
  {
    id: "Bigbag",
    name: "Big bag",
  },
  {
    id: "Bucket",
    name: "Bucket",
  },
  {
    id: "Pallet",
    name: "Pallet",
  },
];
